export default {
  path: "ifta",
  name: 'IFTA',
  component: () => import("@/views/ifta"),
  redirect: "/accounting/ifta/mileage",
  meta: { title: "IFTA", keepName: 'ifta', keepAlive: true },
  children: [
    {
      path: "mileage",
      name: "Mileage Management",
      component: () => import('@/views/ifta/views/mileage'),
      hidden: true,
      meta: { activeMenu: '/accounting/ifta/mileage' },
    },
    {
      path: "fuel",
      name: "Fuel Expense",
      component: () => import('@/views/ifta/views/fuel'),
      hidden: true,
      meta: { activeMenu: '/accounting/ifta/fuel' },
    },
    {
      path: "report",
      name: "IFTA Reports",
      component: () => import('@/views/ifta/views/report'),
      hidden: true,
      meta: { activeMenu: '/accounting/ifta/report' },
    },
    {
      path: "settings",
      name: "Settings",
      component: () => import('@/views/ifta/views/settings'),
      hidden: true,
      meta: { activeMenu: '/accounting/ifta/settings' },
    },
  ]
}
